var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormCoreComponent } from '../form-core';
var OrganisationFormComponent = /** @class */ (function (_super) {
    __extends(OrganisationFormComponent, _super);
    function OrganisationFormComponent() {
        var _this = _super.call(this) || this;
        _this.form = new FormGroup({
            name: new FormControl('', Validators.required),
            enabled: new FormControl(true),
            contactNumber: new FormControl('', Validators.required),
            address: new FormGroup({
                address1: new FormControl('', Validators.required),
                address2: new FormControl(),
                town: new FormControl('', Validators.required),
                state: new FormControl('', Validators.required),
                postcode: new FormControl('', Validators.required),
                country: new FormControl('', Validators.required)
            })
        });
        return _this;
    }
    Object.defineProperty(OrganisationFormComponent.prototype, "organisation", {
        set: function (value) {
            if (value) {
                var result = __assign({}, value);
                result.address = result.address || {};
                this.form.patchValue(result || {}, { emitEvent: false, onlySelf: true });
            }
        },
        enumerable: true,
        configurable: true
    });
    return OrganisationFormComponent;
}(FormCoreComponent));
export { OrganisationFormComponent };
